import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  imageContainer: {
    width: theme.spacing(9),
    height: theme.spacing(9),
    borderRadius: theme.spacing(1),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    position: "relative",
    cursor: "pointer",
  },
  nameContainer: {
    alignItems: "center",
    justifyContent: "flex-end",
  },
  placeholderContainer: {
    backgroundColor: "#F2F2F2",
    border: "1px dashed #DBDBDB",
  },
  placeholder: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    "& svg": {
      color: "#757575",
      fontSize: theme.spacing(3),
    },
  },
  imageWithHover: {
    "& img": {
      transition: "opacity 0.3s ease",
    },
    "&:hover": {
      "& img": {
        opacity: 0.7,
      },
      "& .hoverOverlay": {
        opacity: 1,
      },
    },
  },
  hoverOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    opacity: 0,
    transition: "opacity 0.3s ease",
    "& svg": {
      color: "white",
      fontSize: theme.spacing(3),
    },
  },
}));

export default useStyles;
